<template>
    <div>
        <app-navbar-embed />
        <project-navbar :isViewMode="true"
        />
        <slot></slot>
        <!--<div class="lb-fixed-bottom-center">
            <div class="trapezoid">
                <img
                    src="@/assets/images/logo_eduloc360.png"
                    alt
                    width="145"
                />
            </div>
        </div>-->
    </div>
</template>

<script>
import ProjectNavbar from '@/components/ProjectNavbar';
import AppNavbarEmbed from '@/components/AppNavbarEmbed';
import store from '@/store/index';
import _ from 'underscore';
export default {
    components: {
        //ProjectNavbar,
        AppNavbarEmbed,
        ProjectNavbar
    },
    data() {
        return {
            showResumeModal: false,
            showShareModal: false,
        };
    },
    mounted: function () {
        store
        .dispatch('fetchProjectSimplified', this.$route.params.projectId)
        .catch((e) => {
            console.error('failed to fetch project', e.status || e);
            this.showErrorPage = true;
        })/*.then((project) => {
                if (!this.isLoggedIn && (project.privacy == 'secret' || project.privacy == 'public') && project.allowAnonymous) {
                this.$store
                .dispatch('anonymousLogin', 'anonymous')
                .then(() => {
                    // console.log(this.$store.getters.user);
                });
            }
            })*/;
        
        
        

       
    },
    beforeCreate() {
        // document.body.classList.remove('has-navbar-fixed-top');
    },
    destroyed() {
        // document.body.classList.add('has-navbar-fixed-top');
    },
    computed: {},
    methods: {},
};
</script>

<style scoped>
    @import '../assets/css/project-view.css';

</style>
